export default "__VITE_ASSET__2d34b4cd__"